import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_LIST, GET_VENDOR_LIST_SUCCESS, GET_VENDOR_LIST_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getVendorList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/benefit-type/airport-transfer`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_VENDOR_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_LIST_ERROR, payload: error });
  }
}

export function* watchgetVendorList() {
  yield takeEvery(GET_VENDOR_LIST, getVendorList);
}

function* getVendorListSaga() {
  yield all([fork(watchgetVendorList)]);
}

export default getVendorListSaga;
